import React, { useContext, useEffect, useState } from 'react'

import { Button, Icon, Modal, Table, Typography } from 'antd'
import { get } from 'lodash'
import moment from 'moment'

import { getMessage } from '../../util/IntlMessages'
import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import sortText from '../../util/sortText'
import { api, request } from '../../util/handlerRequestUtil'
import GroupIcon from '../../assets/images/group-icon.svg'
import AlertIcon from '../../assets/images/ico_erro.svg'
import LixeiraIcon from '../../assets/images/lixeira.svg'
import AddIcon from '../../assets/images/adicionar.svg'
import { ActionsPlanContext } from './ActionsPlan'
import AddCustomerList from './AddCustomer.list'

const ActionPlainList = ({ categoriaAcao }) => {
  const {
    filters: { idSafra, idRegion, idDistrict, customerName }
  } = useContext(ActionsPlanContext)
  const [customers, setCustomers] = useState([])
  const [customersNumber, setCustomersNumber] = useState()
  const [selectedRows, setSelectedRows] = useState([])
  const [beginDate, setBeginDate] = useState()
  const [endDate, setEndDate] = useState()
  const [dentroPeriodo, setDentroPeriodo] = useState(true)
  const [isModalLocationVisible, setIsModalLocationVisible] = useState(false)
  const { confirm } = Modal
  const [escapeLocations, setEscapeLocations] = useState([])
  const [removing, setRemoving] = useState(false)

  useEffect(() => {
    fetchCustomers()
  }, [idRegion, idDistrict, customerName, isModalLocationVisible, categoriaAcao])

  async function fetchCustomers() {
    if (!categoriaAcao.id) {
      return false
    }
    try {
      const params = {
        idSafra,
        idRegion,
        idDistrict,
        customerName
      }
      const safra = await api.findSafraByIdForActionPlan(idSafra)
      const inicioSafra = safra.actionPlanningPeriodStartDate
      const fimSafra = safra.actionPlanningPeriodEndDate

      const now = moment().format('YYYY-MM-DD')
      const dentroPeriodo =
        now >= moment(inicioSafra, 'DD/MM/YYYY').format('YYYY-MM-DD') &&
        now <= moment(fimSafra, 'DD/MM/YYYY').format('YYYY-MM-DD')
      setDentroPeriodo(dentroPeriodo)
      setBeginDate(inicioSafra)
      setEndDate(fimSafra)
      const customersAndCount = await request(api.searchCustomersByCategoryAction(categoriaAcao.id, params))
      const customers = customersAndCount[0]
      const numberofCustomers = customersAndCount[1]
      setCustomersNumber(numberofCustomers)
      const formatedRows = []
      customers.map((item) => {
        const redText = categoriaAcao.classificacao > item.eibClassificacao
        return formatedRows.push({
          key: get(item, 'id'),
          customerName: renderComCor(get(item, 'customer_name'), redText),
          locationName: renderComCor(get(item, 'location_name'), redText),
          classificacao: renderClassificationAction(get(item, 'eibClassificacao'), redText),
          status: renderStatusExecutada(item.idStatus),
          idStatus: get(item, 'idStatus'),
          idLocation: get(item, 'location_id'),
          actions: renderCategoryAction(
            categoriaAcao,
            String(get(item, 'idStatus')).trim(),
            get(item, 'id'),
            dentroPeriodo
          )
        })
      })
      setEscapeLocations(
        customers.map((item) => {
          return item.location_id
        })
      )
      setCustomers(formatedRows)
    } catch (error) {
      console.tron.log(error)
    }
  }

  const renderStatusExecutada = (idStatus) => {
    let status = {
      color: '',
      label: ''
    }

    if (idStatus.trim() === 'EXECUTADA') {
      status.color = '#BFF3DF'
      status.label = 'EXECUTADA'
    }
    if (idStatus.trim() === 'CANCELADA') {
      status.color = '#F7BCC8'
      status.label = 'CANCELADA'
    }

    if (idStatus.trim() === 'ABERTA') {
      status.color = '#C7E4FF'
      status.label = 'EM ABERTO'
    }
    return (
      <div className="div-list-status-table">
        <div className="tag-status" style={{ backgroundColor: status.color }}>
          {status.label}
        </div>
      </div>
    )
  }

  const renderComCor = (texto, vermelho) => {
    let cor = '#000000'
    if (vermelho) {
      cor = '#FF0000'
    }
    return <div style={{ color: cor }}>{texto}</div>
  }

  function getCategoryActionColumns() {
    const columns = [
      {
        title: getMessage('customer'),
        dataIndex: 'customerName',
        sorter: (a, b) => sortText(a, b, 'customerName'),
        width: '36%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('locationName'),
        dataIndex: 'locationName',
        sorter: (a, b) => sortText(a, b, 'locationName'),
        width: '30%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('categoryActionClassificationBayer'),
        dataIndex: 'classificacao',
        sorter: (a, b) => sortText(a, b, 'classificacao'),
        width: '10%',
        align: 'center',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('statusAction'),
        dataIndex: 'status',
        sorter: (a, b) => sortText(a, b, 'status'),
        width: '12%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      }
    ]
    columns.push({
      title: getMessage('deleteAction'),
      dataIndex: 'actions',
      width: '7%'
    })
    return columns
  }

  const renderClassificationAction = (id, vermelho) => {
    let cor = '#000000'
    if (vermelho) {
      cor = '#FF0000'
    }
    return (
      <label style={{ marginRight: 10, color: cor }}>
        <Icon type="star" style={{ color: cor, fontSize: 20 }} />
        {'    ' + id}
      </label>
    )
  }

  const renderCategoryAction = (categoriaAcao, status, idLocationPlain, dentroPeriodo) => {
    let disabled = true
    if (status !== 'EXECUTADA' && status !== 'PLANEJADA') {
      disabled = false
    }
    return (
      <div className="group-row-3">
        <Button
          className="default-actionContent-button"
          type="link"
          disabled={disabled || !dentroPeriodo}
          onClick={() => {
            showConfirm(() => {
              deleteAction(idLocationPlain)
            }, `Deseja remover o agricultor participante da ação ${categoriaAcao.name}?`)
          }}
        >
          <img src={LixeiraIcon} alt="" style={{ maxWidth: '60%' }} />
        </Button>
      </div>
    )
  }

  async function deleteAction(idLocationPlain) {
    try {
      await request(api.deleteLocationPlain(idLocationPlain))
      setSelectedRows([])
      fetchCustomers()
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function deleteActions() {
    if (!removing) {
      setRemoving(true)
      try {
        selectedRows.map((row) => {
          api.deleteLocationPlain(row.key)
        })
        fetchCustomers()
        setSelectedRows([])
        setRemoving(false)
      } catch (error_) {
        setRemoving(false)
        console.tron.log(error_)
      }
    }
  }

  function showConfirm(onDeleteFunc, message) {
    confirm({
      title: <img src={AlertIcon} alt="" style={{ marginLeft: '42%' }} />,
      icon: null,
      content: (
        <span style={{ marginLeft: !message ? 90 : 0 }}>
          {!message ? getMessage('SureToDelete?') : getMessage(message)}
        </span>
      ),
      cancelButtonProps: {
        style: {
          width: 148,
          borderColor: '#EE778F',
          color: '#EE778F'
        },
        type: 'ghost'
      },
      okButtonProps: {
        className: 'button-action',
        type: 'primary',
        style: {
          marginRight: 10
        }
      },
      okText: getMessage('label.yes'),
      cancelText: getMessage('label.no'),
      onOk() {
        if (onDeleteFunc) {
          onDeleteFunc()
        }
      },
      onCancel() {}
    })
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows)
    },
    getCheckboxProps: (record) => {
      return {
        disabled: (record.idStatus === 8 || record.idStatus === 9) && record.idStatus !== null
      }
    }
  }

  function renderCategories() {
    return (
      <div style={{ padding: '2%' }}>
        <div className="default-header-div">
          <div className="default-header-breadcrumb">
            <Typography.Title className="default-header-title" level={3}>
              Agricultores participantes ({customersNumber})
            </Typography.Title>
            <div style={{ display: 'flex' }}>
              <span
                style={{ paddingRight: 10, paddingTop: 10 }}
              >{`O período de planejamento das ações vai de ${beginDate} até ${endDate}`}</span>
              <Button
                className="default-actionContent-button"
                type="ghost"
                disabled={selectedRows.length === 0 || !dentroPeriodo || removing}
                onClick={() => {
                  showConfirm(() => {
                    deleteActions()
                  }, `Deseja remover os ${selectedRows.length} agricultores participante da ação ${categoriaAcao.name}?`)
                }}
              >
                <img src={LixeiraIcon} alt="" style={{ width: 25 }} />
                {getMessage('removeSelected')}
              </Button>
              <Button
                className="bgPrimary"
                type="dashed"
                onClick={() => setIsModalLocationVisible(!isModalLocationVisible)}
                disabled={idDistrict == '' || idDistrict == -1 || !dentroPeriodo || !categoriaAcao.active}
                title={idDistrict == '' || idDistrict == -1 ? getMessage('requiredFieldsAddCustomer') : ''}
              >
                <img src={AddIcon} alt="" style={{ width: 20 }} />
                {getMessage('AddCustomer')}
              </Button>
            </div>
            <Modal
              title={getMessage('selectingCustomers')}
              footer={null}
              onCancel={() => {
                setIsModalLocationVisible(!isModalLocationVisible)
              }}
              width="70%"
              visible={isModalLocationVisible}
              onClose={() => {
                setIsModalLocationVisible(!isModalLocationVisible)
              }}
            >
              <AddCustomerList
                categoriaAcao={categoriaAcao}
                setIsModalLocationVisible={setIsModalLocationVisible}
                isModalLocationVisible={isModalLocationVisible}
                escapeLocations={escapeLocations}
              />
            </Modal>
          </div>
        </div>
        {customers.length === 0 ? (
          <div style={{ textAlign: '-webkit-center', margin: '10%' }}>
            <div>
              <img src={GroupIcon} alt="" />
              <Typography
                className="default-header-title"
                style={{ color: '#334863', padding: '10px 0px 10px' }}
                level={3}
              >
                {getMessage('emptyCustomerParticipant')}
              </Typography>
            </div>
          </div>
        ) : (
          <Table
            rowSelection={{
              type: 'checkbox',
              ...rowSelection
            }}
            columns={getCategoryActionColumns()}
            dataSource={customers}
            pagination={false}
          />
        )}
      </div>
    )
  }

  return <>{renderCategories()}</>
}

export default ActionPlainList
